import * as R from 'ramda'
import { useReducer, useCallback } from 'react'
import effects from 'app/effects/effects'
import moment from 'moment'

const SET_PUBLIC_LINK = 'SET_PUBLIC_LINK'
const START_LOADING = 'START_LOADING'
const SET_PUBLIC_LINK_ERROR = 'SET_ERROR'

const initialState = {
  publicLinks: undefined,
  isLoading: false,
  isShowPublicLinks: false,
  error: undefined,
}

function reducer(state, action) {
  switch (action.type) {
    case SET_PUBLIC_LINK: {
      return R.mergeRight(state, {
        publicLinks: action.publicLinks,
        isLoading: false,
        error: undefined,
      })
    }
    case SET_PUBLIC_LINK_ERROR:
      return R.mergeRight(state, {
        publicLinks: undefined,
        isLoading: false,
        error: action.error,
      })
    case START_LOADING:
      return R.mergeRight(state, {
        isLoading: true,
        error: undefined,
      })
    default:
      return state
  }
}

export const useShareNotification = (notificationId, scheduleDate) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const loadNotificationPublicLinks = useCallback(() => {
    if (state.isLoading) return
    dispatch({ type: START_LOADING })
    return effects.apis
      .getPublicNotificationLink({ notificationId: notificationId })
      .then(
        R.compose(
          dispatch,
          R.mergeRight({ type: SET_PUBLIC_LINK }),
          R.objOf('publicLinks'),
        ),
      )
      .catch(
        R.compose(
          dispatch,
          R.mergeRight({ type: SET_PUBLIC_LINK_ERROR }),
          R.objOf('error'),
        ),
      )
  }, [notificationId, dispatch, state.isLoading])

  const handlePublicLinks = R.compose(
    R.sortBy(R.compose(R.prop('name'))),
    R.pathOr([], ['publicLinks']),
  )

  const fetchPublicLinks = () => {
    loadNotificationPublicLinks()
  }
  const isSharingDisabled = R.compose(
    R.ifElse(
      R.isNil,
      R.always(false),
      R.compose((scheduleDate) => scheduleDate.isAfter(moment()), moment),
    ),
  )(scheduleDate)

  return {
    fetchPublicLinks,
    publicLinks: handlePublicLinks(state),
    isSharingDisabled,
    isLoading: state.isLoading,
  }
}
